const language = {
    // common
    'app': 'Aplikacja',
    'request_error': 'Wystąpił błąd - spróbuj ponownie',
    'request_error_refresh': 'Wystąpił błąd - odśwież stronę, by spróbować ponownie',
    'version': 'Wersja',
    'dev_mode': 'Tryb Deweloperski',
    'yes': 'Tak',
    'no': 'Nie',
    'turned_on': 'włączony',
    'turned_off': 'wyłączony',
    'nd': 'n/d',
    'back': 'Powrót',
    'forward': 'Dalej',
    'none': 'Brak',
    'email': 'E-Mail',
    'password': 'Hasło',
    'preview': 'Podgląd',
    'search': 'Szukaj',
    'search_in': 'Szukaj w',
    'refresh': 'Odśwież',
    'add': 'Dodaj',
    'adding': 'Trwa dodawanie...',
    'added': 'Dodano',
    'edit': 'Edytuj',
    'sure_to_remove': 'Czy na pewno chcesz usunąć ten element?',
    'remove': 'Usuń',
    'removing': 'Trwa usuwanie...',
    'removed': 'Usunięto',
    'removed_element': 'Uwaga, ten element jest usunięty i zablokowany do dalszej edycji. Możesz go jednak przywrócić.',
    'sure_to_restore': 'Czy na pewno chcesz przywrócić ten element?',
    'restore': 'Przywróć',
    'restoring': 'Trwa przywracanie...',
    'restored': 'Przywrócono',
    'save': 'Zapisz',
    'saving': 'Trwa zapisywanie...',
    'saved': 'Zapisano',
    'send': 'Wyślij',
    'sending': 'Wysyłanie...',
    'sent': 'Wysłano',
    'change': 'Zmień',
    'changing': 'Trwa zmienianie...',
    'changed': 'Zmieniono',
    'load': 'Wczytaj',
    'loading': 'Wczytywanie...',
    'loading_what': 'Wczytywanie: ',
    'loaded': 'Wczytano',
    'loaded_what': 'Wczytano: ',
    'clear': 'Wyczyść',
    'cleared': 'Wyczyszczono',
    'choose': 'Wybierz',
    'chose': 'Wybrano',
    'open': 'Otwórz',
    'opening': 'Otwieranie',
    'opened': 'Otworzono',
    'close': 'Zamknij',
    'closing': 'Zamykanie',
    'closed': 'Zamyknięto',
    'cancel': 'Anuluj',
    'cancelling': 'Anulowanie',
    'cancelled': 'Anulowano',
    'print_options': 'Opcje wydruku',
    'print': 'Drukuj',
    'print_all': 'Drukuj wszystko',
    'print_with_att': 'Drukuj wraz z załącznikami',
    'as_pdf': 'Pobierz PDF',
    'order_by': 'Sortowanie po',
    'reverse': 'Odwrotnie',
    'all_results': 'Wszystkie',
    'sum': 'Suma',
    'confirm': 'Potwierdź',
    'more': 'Więcej...',
    'get_more_stats': 'Pokaż więcej statystyk',
    'work_in_progress': 'Moduł w trakcie budowy',
    'op_progress': 'Operacja w toku...',
    'op_success': 'Operacja zakończona sukcesem.',
    'op_error': 'Operacja zakończona niepowodzeniem!',
    'description': 'Opis',
    'actions': 'Akcje',
    'fill_all_fields': 'Uzupełnij wszystkie wymagane pola poprawnie.',
    'remember_my_choice': 'Zapamiętaj mój wybór',
    'autosave': 'Autozapis',
    'autosaved': 'Ostatni zapis',
    'new_value': 'Nowa wartość',
    'available_after_save': 'Wybrane akcje dostępne są dopiero po zapisaniu zmian',
    'from': 'od',
    'to': 'do',
    'changes': 'Zmiany',
    'before': 'przed',
    'after': 'po',
    'created_at': 'Czas utworzenia',
    'updated_at': 'Czas zmiany',
    'deleted_at': 'Czas usunięcia',
    'area': 'Obszar',
    'previous_area': 'Poprzedni obszar',
    'area_id': 'Obszar',
    'symbol': 'Kod',
    'amount': 'Liczba',
    'width': 'Szerokość',
    'height': 'Wysokość',
    'depth': 'Długość',

    // pagination
    'pagination.page': 'strona',
    'pagination.from': 'z',
    'pagination.pages': 'stron',
    'pagination.to': 'do',

    // auth
    'auth.sign_in': 'Zaloguj',
    'auth.sign_out': 'Wyloguj',
    'auth.remember_me': 'Zapamiętaj',
    'auth.reset_password': 'Resetuj hasło',
    'auth.reset_password_error': 'Wystąpił błąd. Czy podałeś poprawny email?',
    'auth.reset_password_sent': 'Dalsze instrukcje zostały wysłane na podany adres email. Na ich realizację masz dokładnie jedną godzinę.',
    'auth.reset_password_title': 'VPlaner - Resetowanie hasła do konta',
    'auth.reset_password_bad_token': 'Niepoprawny klucz zmiany hasła. Sprawdź link lub rozpocznij procedurę od początku.',
    'auth.reset_password_expired_token': 'Nieaktualny klucz zmiany hasła. Rozpocznij procedurę od początku.',
    'auth.reset_password_success': 'Hasło zostało poprawnie zresetowane. Twoje nowe hasło to:',
    'auth.signing': 'Trwa logowanie',
    'auth.signin_ok': 'Zalogowano poprawnie, trwa wczytywani aplikacji...',
    'auth.signin_bad_credentials': 'Nieprawidłowe dane',
    'auth.signin_disabled': 'Konto jest zablokowane',
    'auth.signin_too_many_bad_attempts': 'Konto zostało chwilowo zablokowane - zbyt dużo prób logowania się',
    'auth.signin_check_remembered': 'Sprawdzanie zapamiętanych sesji...',
    'auth.no_auth': 'Brak autoryzacji',

    // statuses
    'status.active': 'Aktywny',
    'status.inactive': 'Nieaktywny',
    'status.deleted': 'Usunięty',
    'status.disabled': 'Zablokowany',

    // dashboard
    'dashboard': 'Panel',
    'dashboard.calendars': 'Kalendarze',
    'dashboard.no_data': 'Brak danych',
    'dashboard.task_all': 'Realizacja zadań (cały okres)',
    'dashboard.task_month': 'Realizacja zadań (ostatnie 30 dni)',
    'dashboard.interests_all': 'Realizacja interesów (cały okres)',
    'dashboard.interests_month': 'Realizacja interesów (ostatnie 30 dni)',
    'dashboard.chose_target': 'Wybierz użytkownika, którego dane chcesz zobaczyć',
    'dashboard.chose_crews': 'Wybierz ekipy, których obciążenie chcesz zobaczyć',
    'dashboard.usage': 'Obciążenie (%)',
    'dashboard.time_available': 'Dostępnych minut',
    'dashboard.time_used': 'Zaplanowanych minut',
    'dashboard.time_day': '(dzień)',
    'dashboard.time_week': '(tydzień)',
    'dashboard.time_month': '(miesiąc)',
    'dashboard.main': 'Panel główny',
    'dashboard.stats': 'Statystyki',
    'dashboard.tasks': 'Zadania',
    'dashboard.measurement': 'Pomiary',
    'dashboard.installation': 'Montaż',
    'dashboard.transport': 'Transport',
    'dashboard.service': 'Serwis',

    'dashboard_main': 'Panel główny',
    'dashboard_tasks': 'Kalendarz - zadania',
    'dashboard_measurement': 'Kalendarz - Pomiary',
    'dashboard_installation': 'Kalendarz - Montaż',
    'dashboard_transport': 'Kalendarz - Transport',
    'dashboard_service': 'Kalendarz - Serwis',

    // statusy
    'statuses': 'Statusy',
    'statuses.active': 'Aktywny',
    'statuses.disabled': 'Zablokowany',
    'statuses.deleted': 'Usunięty',

    // users
    'users': 'Użytkownicy',
    'users.list': 'Lista użytkowników',
    'users.add': 'Dodaj użytkownika',
    'users.edit': 'Edytuj użytkownika',
    'users.mass_edit': 'Edytuj masowa',
    'users.mass_action': 'Akcja',
    'users.preview': 'Podgląd danych użytkownika',
    'users.sure_to_delete': 'Czy na pewno chcesz usunąć tego użytkownika?',
    'users.single': 'Pracownik',
    'users.basic': 'Podstawowe',
    'users.groups': 'Grupy',
    'users.permissions': 'Uprawnienia',
    'users.general': 'Dane podstawowe',
    'users.contact': 'Dane kontaktowe',
    'users.email': 'E-Mail',
    'users.password': 'Hasło',
    'users.name': 'Imię',
    'users.surname': 'Nazwisko',
    'users.fullname': 'Imię, Nazwisko',
    'users.stolcad_name': 'Stolcad',
    'users.job_id': 'Stanowisko',
    'users.address': 'Adres',
    'users.alternate_address': 'Adres alternatywny',
    'users.company_phone': 'Tel. służbowy',
    'users.company_cellphone': 'Kom. służbowa',
    'users.private_phone': 'Tel. prywatny',
    'users.skype': 'Skype',
    'users.fax': 'Fax',
    'users.areas': 'Obszary',
    'users.status': 'Status',
    'user_active': 'Aktywny',
    'user_inactive': 'Nieaktywny',
    'user_deleted': 'Usunięty',
    'user_suspended': 'Zawieszony',
    'users.photo': 'Zdjęcie',
    'users.profile': 'Moje konto',
    'users.change_password': 'Zmień hasło',
    'users.new_password': 'Nowe hasło (min. 8 znaków)',
    'users.repeat_new_password': 'Powtórz nowe hasło',
    'users.password_too_easy': 'Wpisane hasło jest zbyt proste!',
    'users.password_doesnt_match': 'Wpisane hasła nie są identyczne!',
    'users.password_changed': 'Hasło zostało zmienione',
    'settings': 'Ustawienia',
    'users.settings': 'Ustawienia',
    'users.settings_colors': 'Kolory',
    'users.settings_high_contrast': 'Wysoki kontrast',
    'users.settings_sidebar': 'Panel boczny',
    'users.settings_sidebar_mini': 'Małe ikony',
    'users.settings_layout': 'Układ strony',
    'users.settings_layout_boxed': 'Stała szerokość',
    'users.remember_to_save': 'Pamiętaj o zapisaniu wprowadzonych zmian.',
    'users.duplicated_email': 'Użytkownik o takim adresie email już istnieje - wybierz inny!',

    // groups
    'groups': 'Grupy',
    'groups.add': 'Dodaj grupę',
    'groups.edit': 'Edytuj grupę',
    'groups.user_description': 'Przypisywanie użytkowników do grup odbywa się w panelu użytkowników (edycja).',
    'groups.name': 'Nazwa grupy',
    'groups.description': 'Opis',
    'groups.author_id': 'Autor',
    'groups.owner_id': 'Zarządca',
    'groups.is_admin': 'Grupa administratorów',
    'groups.status': 'Status',
    'group_active': 'Aktywna',
    'group_inactive': 'Zawieszona',
    'group_disabled': 'Zablokowana',
    'group_deleted': 'Usunięta',

    // dictionaries
    'dictionaries': 'Słowniki',
    'dictionaries.name': 'Nazwa skrócona słownika',
    'dictionaries.description': 'Opis słownika',
    'dictionaries.status': 'Status',
    'dictionaries.key': 'Identyfikator',
    'dictionaries.value': 'Wartość',
    'dictionaries.add_instruction': 'Podaj wartość dla nowej pozycji - lub anuluj operację',
    'dictionaries.list_help': 'Przeciągnij, by zmienić kolejność.',
    'dictionaries.dirty': 'Pamiętaj o zapisaniu zmian.',
    'dictionary_items.key': 'Identyfikator pola słownikowego',
    'dictionary_items.value': 'Wartość pola słownikowego',
    'dictionary_items.order': 'Kolejność',

    // clients
    'clients': 'Baza klientów',
    'clients.list': 'Lista klientów',
    'clients.add': 'Dodaj klienta',
    'clients.edit': 'Edytuj klienta',
    'clients.base_info': 'Dane podstawowe',
    'clients.name': 'Nazwa',
    'clients.nip': 'NIP',
    'clients.other_id': 'Inny nr identyfikujący',
    'clients.author_id': 'Autor wpisu',
    'clients.address_name': 'Adresat',
    'clients.address_city': 'Miasto',
    'clients.address_street': 'Ulica',
    'clients.address_postcode': 'Kod pocztowy',
    'clients.address_country_id': 'Państwo',
    'clients.contact_info': 'Dane kontaktowe',
    'clients.contact_name': 'Adresat',
    'clients.contact_city': 'Miasto',
    'clients.contact_street': 'Ulica',
    'clients.contact_postcode': 'Kod pocztowy',
    'clients.contact_country_id': 'Państwo',
    'clients.email': 'E-Mail',
    'clients.skype': 'Skype',
    'clients.website': 'Strona www',
    'clients.phone': 'Telefon',
    'clients.alternative_phone': 'Telefon(2)',
    'clients.fax': 'Fax',
    'clients.notes': 'Notatki',
    'clients.status': 'Status',
    'clients.photo': 'Zdjęcie',
    'clients.preview': 'Szybki podgląd',
    'clients.are_you_sure': 'Czy na pewno chcesz dodać nowego klienta do bazy?',
    'clients.copy_data': 'Skopiuj z danych klienta',
    'clients.copy_data_empty': 'Brak prawidłowych danych do skopiowania',
    'clients.wrong_name': 'Nazwa klienta powinna być dłuższa!',

    'client_active': 'Aktywny',
    'client_inactive': 'Nieaktywny',
    'client_deleted': 'Usunięty',
    'client_suspended': 'Zawieszony',

    'investments': 'Inwestycje',
    'investments.name': 'Inwestycja',
    'investments.client_id': 'Klient',
    'investments.status': 'Status',
    'investments.description': 'Opis inwestycji',
    'investments.add': 'Dodaj inwestycję',
    'investments.edit': 'Edytuj inwestycję',

    // interests
    'interests': 'Interesy',
    'interests.list': 'Lista interesów',
    'interests.add': 'Dodaj interes',
    'interests.edit': 'Edycja interesu',
    'interests.preview': 'Podgląd interesu',
    'interests.base_info': 'Informacje podstawowe',
    'interests.project_id': 'Zlecenie',
    'interests.related_projects': 'Powiązane zlecenia',
    'interests.relation_type': 'Rodzaj relacji',
    'interests.relation_type_direct': 'Na bazie interesu',
    'interests.relation_type_related': 'Powiązany',
    'interests.symbol_code': 'Symbol globalny',
    'interests.area_code': 'Symbol w obszarze',
    'interests.phase_id': 'Etap',
    'interests.name': 'Nazwa skrócona',
    'interests.client_id': 'Klient',
    'interests.author_id': 'Autor',
    'interests.owner_id': 'Koordynator',
    'interests.manager_id': 'Realizuje',
    'interests.notification_recipients': 'Odbiorcy powiadomień',
    'interests.woodwork_id': 'Stolarka',
    'interests.value': 'Wartość w PLN',
    'interests.currency_id': 'Waluta faktury',
    'interests.estimated': 'Szac. wartość w PLN',
    'interests.notes': 'Notatki',
    'interests.status_id': 'Status',
    'interests.loss_id': 'Powód przegranej',
    'interests.description': 'Opis',

    // tasks
    'tasks': 'Zadania',
    'tasks.list': 'Lista zadań',
    'tasks.add': 'Dodaj zadanie',
    'tasks.edit': 'Edycja zadania',
    'tasks.preview': 'Podgląd zadania',
    'tasks.base_info': 'Dane podstawowe',
    'tasks.about_who': 'Dotyczy',
    'tasks.symbol_code': 'Symbol globalny',
    'tasks.area_code': 'Symbol w obszarze',
    'tasks.name': 'Zadanie',
    'tasks.client_id': 'Klient',
    'tasks.interest_id': 'Interes',
    'tasks.category_id': 'Kategoria',
    'tasks.status_id': 'Status',
    'tasks.author_id': 'Autor',
    'tasks.owner_id': 'Realizuje',
    'tasks.notification_recipients': 'Odbiorcy powiadomień',
    'tasks.date_from': 'Realizacja od',
    'tasks.date_to': 'Realizacja do',
    'tasks.notes': 'Notatki',
    'tasks.color': 'Kolor',
    'tasks.about_choose': 'Wybierz podmiot',

    // reminders
    'reminders': 'Przypomnienia',
    'reminders.reminder': 'Przypomnienie',
    'reminders.task': 'Zadanie',
    'reminders.no_results': 'Brak zdefiniowanych przypomnień dla tego zadania.',
    'reminders.legend': 'Np. aby otrzymywać powiadomienia co 2 dni, należy wybrać odpowiednio: <b>dzień</b>, <b>2</b> oraz zakres dat i godzinę wystąpienia powiadomienia. Można też wskazać dni kalendarzowe (<b>wybrane dni</b>, <b>1,10</b> - każdy 1 i 10 dzień miesiąca).',
    'reminders.add': 'Dodaj przypomnienie',
    'reminders.edit': 'Edytuj przypomnienie',
    'reminders.name': 'Treść',
    'reminders.task_id': 'Dla zadania',
    'reminders.repeat': 'Powtarzaj',
    'reminders.day': 'Dzień',
    'reminders.week': 'Tydzień',
    'reminders.month': 'Miesiąc',
    'reminders.year': 'Rok',
    'reminders.days': 'Wybrane dni miesiąca',
    'reminders.repeat_by': 'Powtarzaj co/w',
    'reminders.start_from': 'Zacznij od',
    'reminders.at_time': 'O godzinie',
    'reminders.until': 'Aż do',
    'reminders.system': 'Wyświetlaj w systemie',
    'reminders.email': 'Wysyłaj na mail',
    'reminders.evaluated_count': 'Pozostało do wysłania',

    // notifications
    'notifications': 'Powiadomienia',
    'notifications.set_as_readed': 'Oznacz jako przeczytana',
    'notifications.set_as_readed_all': 'Oznacz wszystkie jako przeczytane',
    'notifications.readed': 'Przeczytana',
    'notifications.goto': 'Zobacz',
    'notifications.no_desc': 'brak opisu',
    'notifications.create': 'Utworzono',
    'notifications.update': 'Zmieniono',
    'notifications.remove': 'Usunięto',
    'notifications.restore': 'Przywrócono',
    'notifications.info': 'Informacja',

    'notifications.tasks': 'zadanie',
    'notifications.interests': 'interes',
    'notifications.projects': 'zlecenie',
    'notifications.interests_projects': 'powiązane zlecenie',
    'notifications.phases': 'etap',
    'notifications.phases_related': 'powiązany etap',
    'notifications.phase_crews': 'wykonującą ekipę',
    'notifications.phase_woodworks': 'stolarkę',
    'notifications.clients': 'klienta',
    'notifications.users': 'użytkownika',
    'notifications.groups': 'grupę',

    'descriptions.project': '%s <strong>%s</strong> %s dla %s',
    'descriptions.phase': '%s <strong>%s</strong> %s dla %s dnia <strong>%s</strong> o <strong>%s</strong>',
    'descriptions.task': '<strong>%s</strong> %s dla %s dnia <strong>%s</strong>',
    'descriptions.interest': '<strong>%s</strong> %s dla %s',

    // projects
    'projects': 'Zlecenia',
    'projects.list': 'Lista zleceń',
    'projects.add': 'Dodaj zlecenie',
    'projects.edit': 'Edycja zlecenia',
    'projects.show': 'Podgląd zlecenia',
    'projects.preview': 'Podgląd zlecenia',
    'projects.base_info': 'Dane podstawowe zlecenia',
    'projects.phases': 'Etapy',
    'projects.about_who': 'Dotyczy',
    'projects.based_on_interest': 'Zlecenie na bazie interesu:',
    'projects.name': 'Nazwa skrócona',
    'projects.no_name': '(brak nazwy)',
    'projects.project_name': 'Nazwa skrócona zlecenia',
    'projects.symbol': 'Symbol',
    'projects.symbol_code': 'Symbol globalny',
    'projects.area_code': 'Symbol w obszarze',
    'projects.client_id': 'Klient',
    'projects.investment_id': 'Inwestycja',
    'projects.interest_id': 'Interes',
    'projects.related_interests': 'Powiązane interesy',
    'projects.status_id': 'Status',
    'projects.author_id': 'Autor',
    'projects.owner_id': 'Realizuje',
    'projects.notification_recipients': 'Odbiorcy powiadomień',
    'projects.started': 'Realizacja od',
    'projects.notes': 'Notatki',
    'projects.description': 'Notatki',
    'projects.color': 'Kolor',
    'projects.type': 'Rodzaj zlecenia',
    'projects.project': 'Zlecenie',
    'projects.no_project': 'Błąd wczytywania: brak zlecenia',
    'projects.not_all_phases_ready': 'Nie zakończono jeszcze wszystkich etapów zlecenia!',
    'projects.measurement': 'Pomiar',
    'projects.measurement_short': 'P',
    'projects.installation': 'Montaż',
    'projects.installation_short': 'M',
    'projects.transport': 'Transport',
    'projects.transport_short': 'T',
    'projects.service': 'Serwis',
    'projects.service_short': 'S',

    // phases
    'phases': 'Etapy',
    'phases.list': 'Lista etapów',
    'phases.add': 'Dodaj etap',
    'phases.edit': 'Edycja etapu',
    'phases.preview': 'Podgląd etapu',
    'phases.back': 'Powrót',
    'phases.related': 'Powiązane etapy',
    'phases.base_info': 'Dane podstawowe etapu',
    'phases.phases': 'Etapy',
    'phases.about_who': 'Dotyczy',
    'phases.name': 'Nazwa skrócona etapu',
    'phases.client_id': 'Klient',
    'phases.interest_id': 'Interes',
    'phases.category_id': 'Typ',
    'phases.project_id': 'Zlecenie',
    'phases.status_id': 'Status',
    'phases.grade_id': 'Ocena',
    'phases.author_id': 'Autor',
    'phases.owner_id': 'Koordynator',
    'phases.manager_id': 'Realizuje',
    'phases.notification_recipients': 'Odbiorcy powiadomień',
    'phases.date_from': 'Realizacja od',
    'phases.date_from_limit_can_confirm_transport': 'Uwaga! Transport w danym dniu niemożliwy. Wymagana akceptacja przez dział transportu i logistyki.',
    'phases.date_from_limit_can_confirm_installation': 'Uwaga! Montaż w danym dniu niemożliwy. Wymagana akceptacja przez dział montażu.',
    'phases.date_from_limit_needs_confirmation': 'Uwaga! Etap w tym terminie jedynie za akceptacją administratorów:',
    'phases.date_approved': 'Akceptacja',
    'phases.date_to': 'Realizacja do',
    'phases.date_range': 'Realizacja od-do',
    'phases.time_of_service': 'Ustalona godzina usługi',
    'phases.phone': 'Telefon',
    'phases.time_calculated': 'Wyliczony czas realizacji (minuty)',
    'phases.time_needed': 'Szacowany czas realizacji (minuty)',
    'phases.time_recorded': 'Rzeczywisty czas realizacji (minuty)',
    'phases.notes': 'Notatki',
    'phases.description': 'Notatki',
    'phases.color': 'Kolor',
    'phases.type': 'Rodzaj zlecenia',
    'phases.realisation': 'Realizacja',
    'phases.realisation_conditional': 'Warunkowa',
    'phases.realisation_unconditional': 'Bezwarunkowa',
    'phases.symbol': 'Symbol etapu',
    'phases.symbol_code': 'Symbol globalny',
    'phases.area_code': 'Symbol w obszarze',
    'phases.number': 'Numer etapu',
    'phases.stolcad_number': 'Nr Stolcad',
    'phases.crew_id': 'Ekipy',
    'phases.crew_ids': 'Ekipy',
    'phases.show_crew_calendar': 'Pokaż kalendarz',
    'phases.woodwork_id': 'Typ stolarki',
    'phases.woodwork_unit_id': 'Jednostka',
    'phases.woodwork_type_id': 'Typ montażu',
    'phases.woodwork_value': 'Ilość',
    'phases.address': 'Adres odbiorcy',
    'phases.address_delivery': 'Adres dostawy',
    'phases.country_id': 'Kraj usługi',
    'phases.location_id': 'Miasto usługi',
    'phases.value': 'Wartość',
    'phases.value_measurement': 'Koszt pomiaru',
    'phases.value_installation': 'Montaż NETTO',
    'phases.value_installation_gross': 'Montaż BRUTTO',
    'phases.value_transport': 'Koszt transportu',
    'phases.value_service': 'Koszt serwisu',
    'phases.currency_id': 'Waluta',
    'phases.vat_id': 'Stawka VAT',
    'phases.measurement': 'Pomiar',
    'phases.installation': 'Montaż',
    'phases.transport': 'Transport',
    'phases.service': 'Serwis',
    'phases.service_type_id': 'Rodzaj serwisu',
    'phases.service_work_id': 'Prace serwisowe',
    'phases.service_work_value': 'Koszt',
    'phases.service_work_value_sum': 'Suma',
    'phases.service_reason_id': 'Powód uszkodzenia',
    'phases.warranty_reason_id': 'Powód reklamacji',
    'phases.service_work_templates': 'Szablony dodawania prac',
    'phases.transport_type_id': 'Rodzaj transportu',
    'phases.packaging_method_id': 'Sposób pakowania',
    'phases.transport_details': 'Transport',
    'phases.transport_emails': 'E-Mail',
    'phases.transport_email_to': 'Do',
    'phases.transport_email_title': 'Tytuł',
    'phases.transport_email_body': 'Treść',
    'phases.transport_email_save_first': 'Zapisz etap, aby móc wysłać e-mail.',
    'phases.transport_email_to_required': 'Podaj adres odbiorcy (Do).',
    'phases.transport_email_sent_list': 'Wysłane e-maile',
    'phases.transport_email_sent_at': 'Data wysłania',
    'phases.transport_email_sent_by': 'Wysłane przez',
    'phases.transport_email_no_logs': 'Brak wysłanych e-maili dla tego etapu.',
    'phases.transport_email_template_title': 'Informacja o wysyłce i dostawie zamówienia ',
    'phases.transport_email_template_body': 'Uprzejmie informujemy, że wysyłka Państwa zamówienia została zaplanowana.\nPlanowana data dostawy: %date%\nNumer telefonu do kierowcy: %phone%\nNumery zamówienia Stolcad:\n- %stolcad%\n\nW razie pytań lub potrzeby dodatkowych informacji pozostajemy do Państwa dyspozycji.',
    'phases.stands': 'Stojaki',
    'phases.waybill': 'List przewozowy',
    'phases.carrier_id': 'Przewoźnik',
    'phases.carrier_plate': 'Nr Rejestracyjny',
    'phases.dispatched_woodwork': 'Wysłana stolarka',

    'phases.print': 'Wydruki zbiorcze',
    'phases.print_for_day': 'Wydruk dzienny',
    'phases.user_or_crew': 'Ekipa/Pracownik',
    'phases.date': 'Wydruk dla daty',
    'phases.person_from': 'Osoba zlecająca',
    'phases.person_to': 'Osoba przyjmująca zlecenie',
    'phases.default_unit': 'szt.',

	'phases.approvals': 'Akceptacja zleceń',
	'phases.approvals_week': 'Tydzień nr:',
	'phases.approvals_lock': 'Zablokuj',
	'phases.approvals_unlock': 'Odblokuj',
	'phases.approvals_status': 'Status zlecenia',
	'phases.approvals_day_locked': 'Dzień, na który zlecono montaż/transport, jest zablokowany. Nie można już edytować stolarki.',

    // attachments
    'attachments': 'Załączniki',
    'attachments.droparea_message': 'Upuść pliki do przesłania w tym obszarze lub kliknij tutaj:',
    'attachments.choose': 'Wybierz',
    'attachments.uploading': 'Trwa przesyłanie plików...',
    'attachments.uploaded': 'Pliki zostały przesłane.',
    'attachments.download': 'Pobierz',
    'attachments.as_pdf': 'Pobierz jako PDF',
    'attachments.as_csv': 'Pobierz jako CSV',
    'attachments.inline': 'Otwórz w przeglądarce',
    'attachments.file_name': 'Nazwa',
    'attachments.file_ext': 'Rozszerzenie',
    'attachments.file_type': 'Typ',
    'attachments.size': 'Rozmiar',
    'attachments.author': 'Dodał',
    'attachments.created': 'Dodano',
    'attachments.no_results': 'Brak dodanych załączników',
    'attachments.add_after_save': 'Dodawanie załączników możliwe dopiero po zapisaniu aktualnych zmian',

    // areas
    'areas': 'Obszary',
    'areas.list': 'Lista obszarów',
    'areas.add': 'Dodaj obszar',
    'areas.edit': 'Edytuj obszar',
    'areas.move_to': 'Przekaż',
    'areas.move_to_label': 'Przekaż do wskazanego obszaru',
    'areas.move_to_desc': 'Uwaga! Po przekazaniu stracisz możliwość dokonywania wszelkich zmian!',
    'areas.read_only': 'Uwaga! Obiekt przekazany do innego obszaru - obecnie tylko do odczytu!',
    'areas.current_area': 'Obecnie obiekt należy do obszaru',
    'areas.choose_area': 'Wybierz obszar',
    'areas.will_be_moved': 'Obiekt zostanie przekazany do',
    'areas.moved': 'Obiekt został przekazany do wybranego obszaru.',
    'areas.belongs_to': 'Obiekt należy do obszaru',
    'areas.base_info': 'Dane podstawowe',
    'areas.to_default': 'Przywróć domyślną',
    'areas.area_id': 'Obszar',
    'areas.symbol': 'Kod',
    'areas.name': 'Nazwa',
    'areas.description': 'Opis',
    'areas.settings': 'Ustawienia',
    'areas.managers': 'Osoby odpowiedzialne za przydzielanie przekazanych obiektów',
    'areas.no_users': 'Uwaga! Najpierw należy przypisać użytkowników do obszaru.',
    'areas.user_bind_do': 'Uwaga! Użytkownik na stałe będzie przypisany do tego obszaru:',
    'areas.group_bind_do': 'Uwaga! Grupa na stałe będzie przypisana do tego obszaru:',
    'areas.defaults': 'Wartości domyślne',
    'areas.defaults_currency_id': 'Waluta',
    'areas.defaults_country_id': 'Kraj',
    'areas.defaults_unit_piece_id': 'Jednostka',
    'areas.defaults_interest_status_id': 'Status nowego interesu',
    'areas.defaults_interest_win_id': 'Wygrany interes',
    'areas.defaults_interest_loss_id': 'Przegrany interes',
    'areas.defaults_task_status_id': 'Status nowego zadania',
    'areas.defaults_task_unfinished_id': 'Status niedokończonego zadania',
    'areas.defaults_task_category_id': 'Kategoria nowego zadania',
    'areas.defaults_project_status_started': 'Status rozpoczętego zlecenia',
    'areas.defaults_project_status_closed': 'Status zakończonego zlecenia',
    'areas.defaults_phase_status_started': 'Status rozpoczętego etapu',
    'areas.defaults_phase_status_closed': 'Status zakończonego etapu',
    'areas.defaults_crew_id_measurement': 'Ekipa dla pomiaru',
    'areas.defaults_crew_id_installation': 'Ekipa dla montażu',
    'areas.defaults_crew_id_service': 'Ekipa dla serwisu',
    'areas.defaults_crew_id_transport': 'Ekipa dla transportu',
    'areas.defaults_phase_daily_limit_installation': 'Liczba Montaży bez akceptacji na dzień',
    'areas.defaults_phase_daily_limit_transport': 'Liczba Transportów bez akceptacji na dzień',
    'areas.defaults_phase_daily_limit_transport_message': 'Komunikat dot. akceptacji Transportów',
    'areas.defaults_phase_minimum_days_buffer_installation': 'Min. liczba dni kalendarzowych przed dozwoloną datą zlecenia Montażu',
    'areas.defaults_notify_about_complaint': 'Przypomnij o reklamacji po x dniach',
    'areas.calculations': 'Tabele przeliczników',
    'areas.calculations_grid': 'Tabela przeliczników - usługi',
    'areas.calculations_description': 'Podaj przybliżony czas montażu (w minutach).',
    'areas.woodwork_type': 'Typ stolarki',
    'areas.woodwork_unit': 'Jednostka',
    'areas.installations': 'Rodzaj montażu',
    'areas.calculations_workers': 'Tabela przeliczników - pracownicy',
    'areas.workers_description': 'Podaj ilość pracowników oraz ich przybliżony czas pracy (w minutach).',
    'areas.workers_time': 'Dostępny czas pracy pracownika (w minutach).',
    'areas.workers_measurement': 'Ilość pomiarowców',
    'areas.workers_installation': 'Ilość montażystów',
    'areas.workers_transport': 'Ilość kierowców',
    'areas.workers_service': 'Ilość serwisantów',

    // help
    'help': 'Pomoc',
    'help.save_pdf': 'Pobierz instrukcję użytkownika',

    // profil
    'profile': 'Moje konto',

    // header
    'header.clear_cache': 'Wyczyść cache',

    // filter
    'filter': 'Filtr',
    'filter.simple': 'Filtr',
    'filter.quick_search': 'Szybkie wyszukiwanie',
    'filter.name': 'Nazwa filtru:',
    'filter.saved': 'Filtr został zapisany',
    'filter.no_saved': 'Brak zapisanych filtrów',
    'filter.last_used': 'Ostatnio użyty',
    'filter.results': 'Wyników',
    'filter.max_results': 'Ograniczenie wyników',
    'filter.no_results': 'Brak wyników',
    'filter.area_from_any': 'Przekazane Z dowolnego obszaru',
    'filter.area_from_prefix': 'Przekazane Z: ',
    'filter.area_to_any': 'Skierowane DO dowolnego obszaru',
    'filter.area_to_prefix': 'Skierowane DO: ',
    'filter.date_from': 'Od',
    'filter.date_to': 'Do',
    'filter.created_at_from': 'Utworzony od',
    'filter.created_at_to': 'Utworzony do',
    'filter.updated_at_from': 'Modyfikowany od',
    'filter.updated_at_to': 'Modyfikowany do',
    'filter.deleted_at_from': 'Usunięty od',
    'filter.deleted_at_to': 'Usunięty do',
    'filter.with_deleted': 'Usunięte',
    'filter.with_deleted_none': 'Nie pokazuj',
    'filter.with_deleted_also': 'Wraz z innymi',
    'filter.with_deleted_only': 'Tylko usunięte',
    'filter.run': 'Zastosuj',
    'filter.active': 'Filtr aktywny',
    'filter.toggle': 'Pokaż/ukryj filtr',
    'filter.show': 'Pokaż filtr',
    'filter.clear': 'Resetuj',
    'filter.refresh': 'Odśwież filtr',
    'filter.loading': 'Trwa filtrowanie...',
    'filter.global': 'Szukaj wszędzie',
    'filter.global_no_results': 'Brak wyników - spróbuj zastosować inne kryteria wyszukiwania',

    // datatables
    'datatables.show_columns': 'Kolumny',

    // permissions
    'permissions': 'Uprawnienia',
    'permissions.read': 'przeglądanie',
    'permissions.read_all': 'przeglądanie wszystkich',
    'permissions.write': 'uzupełnianie',
    'permissions.write_all': 'uzupełnianie wszystkich',
    'permissions.manage': 'zarządzanie (możliwość usuwania)',
    'permissions.manage_all': 'zarządzanie wszystkimi (możliwość usuwania)',
    'permissions.administrator': 'administrator',
    'permissions.period_summary': 'Raport okresowy',
    'permissions.phases_approval': 'akceptacja zleceń',

    // history
    'history': 'Historia zmian',
    'history.no_results': 'Brak zarejestrowanych zmian',
    'history.author_id': 'Autor zmian',
    'history.default_author': 'System',
    'history.from': 'Przed zmianą',
    'history.to': 'Po zmianie',
    'history.change': 'Zmiana pola: ',
    'history.insert': 'Utworzono',
    'history.update': 'Zmieniono',
    'history.delete': 'Usunięto',
    'history.restore': 'Przywrócono',

    // print
    'print.print': 'Generuj wydruk',
    'print.print_display': 'Wyświetl PDF w przeglądarce',
    'print.generated': 'Wygenerowano',
    'print.author': 'Wygenerował',
    'print.choose_attachments': 'Wybierz załączniki:',
    'print.with_attachments': 'Pobierz PDF wraz z załącznikami typu PDF',
    'print.can_take_a_while': 'Generowanie dokumentu może zająć trochę czasu - prosimy o cierpliwość.',

    // statistics
    'statistics': 'Statystyki',
    'statistics.no_data': 'Brak danych',

    // reports
    'reports': 'Zestawienia',
    'reports.period_summary': 'Wydruk okresowy',
    'reports.service_costs': 'Koszty serwisu',
    'reports.details': 'Dołącz szczegóły',
    'reports.dates': 'Zakres dat',
    'reports.statuses': 'Statusy uwzględnionych prac',
    'reports.all_of_woodworks': 'Pokaż całą stolarkę',
    'reports.grades': 'Oceny za okres',

    // system messages
    'system.sure_to_leave': 'Czy na pewno chcesz odświeżyć/zamknąć aplikację? Możesz utracić wprowadzone zmiany',
};

if ('undefined' !== typeof angular) {
    angular.module('app.config').config(($translateProvider) => {
        $translateProvider.translations('pl', language);
    });
}
